import { TCustomerState } from './CustomerState.types';

/**
 * Gets the applicant from customer state
 * @param customer_state: TAccount- An Account object
 * @returns The applicant or undefined
 */
export const getCustomerStateApplicant = (customerState: TCustomerState) => {
    if (!customerState.application || !customerState.application.people) {
        return undefined;
    }
    const people = customerState.application.people;

    const applicant = people?.find((person) =>
        person.roles?.find((role) => role === 'applicant')
    );
    return applicant || undefined;
};
